module.exports = __webpack_public_path__ + "static/img/qrcode.37015a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.png
// module id = jWhC
// module chunks = 1